import { UserContext } from "contexts/UserContext"
import { useContext } from "react"
import RafiVPosParams from "./RafiVPosParams"
import SimplePayParams from "./SimplePayParams"

export default function AgentParams({ agent, selected }) {
  const { userCards } = useContext(UserContext)

  switch (agent?.useOnline?.profileType) {
    case "rafiVPOS":
      return (
        <RafiVPosParams
          cards={userCards?.raiffeisen}
          agent={agent}
          selected={selected}
        />
      )
    case "simplePay":
      return (
        <SimplePayParams
          cards={userCards?.simplepay}
          agent={agent}
          selected={selected}
        />
      )
    default:
      return null
  }
}
